import {CSSProperties, useEffect, useState} from 'react';
import {FieldValues, FormProvider, SubmitHandler, useForm} from 'react-hook-form';
import LoginForm from '../components/LoginForm';
import ValidatoinForm, {ValidatoinFormConfig} from '../components/ValidationForm';
import FormDataRecord from '../models/formDataRecord';
import UserService from '../services/userService';

import './CSS/Join.css';

const Join: React.FC = () => {
    const methods = useForm();
    const getValues = methods.getValues;

    const [erorrMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState<FormDataRecord[]>([]);

    const [formStyle, setFormStyle] = useState<CSSProperties>({display: 'block'});
    const [confirmStyle, setConfirmStyle] = useState<CSSProperties>({display: 'none'});
    const [completeStyle, setCompleteStyle] = useState<CSSProperties>({display: 'none'});

    useEffect(() => {});

    /**
     * 登録処理を行います。
     * @param data フォームのデータを指定します。
     * @param event フォームのイベントハンドラーを指定します。
     */
    const onSubmit: SubmitHandler<FieldValues> = (data, event) => {
        setErrorMessage('');
        event?.preventDefault();

        const formDataRecords = new Array<FormDataRecord>();

        const accountName = new FormDataRecord();
        accountName.name = '名前';
        accountName.value = getValues('accountName');

        const mailAddress = new FormDataRecord();
        mailAddress.name = 'メールアドレス';
        mailAddress.value = getValues('mailAddress');

        formDataRecords.push(accountName);
        formDataRecords.push(mailAddress);

        setFormData(formDataRecords);
        setFormStyle({display: 'none'});
        setConfirmStyle({display: 'block'});
    };

    const onClickConfirmButton: SubmitHandler<FieldValues> = (data, event) => {
        event?.preventDefault();

        const service = new UserService();

        const accountName = getValues('accountName');
        const mailAddress = getValues('mailAddress');
        const password = getValues('password');

        const createUserPromise = service.createUser(accountName, mailAddress, password);

        createUserPromise
            .then(() => {
                setConfirmStyle({display: 'none'});
                setCompleteStyle({display: 'block'});
            })
            .catch((reson) => {
                setErrorMessage(reson.message);
            });
    };

    const onClickBackButton = () => {
        setFormStyle({display: 'block'});
        setConfirmStyle({display: 'none'});
    };

    const fields = [
        {
            name: 'accountName',
            label: 'アカウント名',
            type: 'text',
            rules: {
                required: '必須項目です。',
                minLength: {
                    value: 6,
                    message: '6文字以上で入力してください。',
                },
                maxLength: {
                    value: 32,
                    message: '32文字以内で入力してください。',
                },
            },
        },
        {
            type: 'email',
            name: 'mailAddress',
            label: 'メールアドレス',
            rules: {
                required: '必須項目です。',
                pattern: {
                    value: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                    message: 'メールアドレスに使用できない文字があります。',
                },
                maxLength: {
                    value: 127,
                    message: '127文字以内で入力してください。',
                },
            },
        },
        {
            type: 'password',
            name: 'password',
            label: 'パスワード',
            rules: {
                required: '必須項目です。',
                minLength: {
                    value: 8,
                    message: '8文字以上で入力してください。',
                },
                maxLength: {
                    value: 32,
                    message: '32文字以内で入力してください。',
                },
            },
        },
        {
            type: 'password',
            name: 're-password',
            label: 'パスワード(再入力)',
            rules: {
                required: '必須項目です。',
                minLength: {
                    value: 8,
                    message: '8文字以上で入力してください。',
                },
                maxLength: {
                    value: 32,
                    message: '32文字以内で入力してください。',
                },
                validate: (input: any) => {
                    if (input !== getValues('password')) {
                        return 'パスワードが一致しません。';
                    }
                    return true;
                },
                onkeyup: (input: any) => {
                    if (input !== getValues('password')) {
                        return 'パスワードが一致しません。';
                    }
                    return true;
                },
            },
        },
    ];

    const formConfig: ValidatoinFormConfig = {
        fields: fields,
        submitButtonText: '送信',
        enableSubmitButton: true,
        enableCancelButton: false,
        cancelButtonText: '',
        submitCallback: onSubmit,
    };

    return (
        <div id='JoinPage' className='page'>
            <div className='content'>
                <div id='join-form' style={formStyle}>
                    <FormProvider {...methods}>
                        <ValidatoinForm config={formConfig}></ValidatoinForm>
                    </FormProvider>
                </div>
                <div id='confirm' style={confirmStyle}>
                    {formData.map((record, index) => {
                        return (
                            <dl key={index}>
                                <dt>{record.name}</dt>
                                <dd>{record.value}</dd>
                            </dl>
                        );
                    })}
                    <div className='error'>{erorrMessage}</div>
                    <div className='form-control'>
                        <button onClick={onClickBackButton}>戻る</button>
                        <button onClick={onClickConfirmButton} className='danger'>
                            登録
                        </button>
                    </div>
                </div>
                <div id='complete' style={completeStyle}>
                    登録が完了しました。
                    <LoginForm></LoginForm>
                </div>
            </div>
        </div>
    );
};

export default Join;
